interface PreviewImageProps {
	clickHandler: () => void;
	title: React.ReactNode;
	url: string;
	alt: string;
}

const PreviewImage = ({ clickHandler, title, url, alt }: PreviewImageProps) => {
	return (
		<button
			onClick={clickHandler}
			className="group relative overflow-hidden"
		>
			<div className="h-full w-full brightness-[0.7] transition-all duration-300 group-hover:brightness-100">
				<img
					className="h-full w-full object-cover transition-all duration-[120s] ease-out group-hover:scale-[2]"
					src={url}
					alt={alt}
				/>
			</div>
			<h1 className="absolute top-6 left-4 transform text-left text-3xl text-white transition-all duration-1000 group-hover:translate-y-10 group-hover:opacity-0">
				{title}
			</h1>
			<div className="absolute top-[50%] left-[50%] flex h-20 w-20 -translate-y-[50%] -translate-x-[50%] scale-50 items-center justify-center rounded-full bg-black/60 opacity-0 transition-all duration-500 group-hover:scale-125 group-hover:opacity-100">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					className=" h-12 w-12  text-white"
					fill="none"
					viewBox="0 0 24 24"
					stroke="currentColor"
					strokeWidth={2}
				>
					<path
						strokeLinecap="round"
						strokeLinejoin="round"
						d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"
					/>
				</svg>
			</div>
		</button>
	);
};

export default PreviewImage;
